// PDF React View
import { Notifier } from "@airbrake/browser";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { env } from "configs/EnvironmentConfig";
import { USB_TOKEN_URL } from "constants/FormatDataContanst";
import {
  ERROR_CONNECT_TOOL_USB,
  ERROR_GET_INFO_USB,
  GET_INFO_USB,
} from "constants/IssueInvoiceConstant";
import {
  generateInputField,
  generateSelectField,
} from "helpers/form_helper_old";
import { downloadToolUsbToken } from "helpers/utils";
import client from "lcs-usbtoken";
// import pdf2base64 from "pdf-to-base64";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import {
  generateNumberInvoice,
  resetDownloadXmlIssueInvoice,
  resetGenerateNumberInvoice,
  resetTransferUsbInvoice,
  transferUsbInvoice,
} from "store/actions";
import { USER_INFO } from "store/auth/login/actionTypes";
import {
  DOWNLOAD_XML_ISSUE_INVOICE_FAIL,
  DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS,
  GENERATE_NUMBER_INVOICE_FAIL,
  GENERATE_NUMBER_INVOICE_SUCCESS,
  TRANSFER_USB_INVOICE_FAIL,
  TRANSFER_USB_INVOICE_SUCCESS,
} from "store/issue-invoice/actionTypes";
import * as yup from "yup";
const VerifyPinUSBModal = props => {
  const {
    isOpen,
    isCreateAdjust,
    toggle,
    t,
    resetDataFunc,
    transferData,
    typeInvoiceAnother,
    downloadXmlFunc,
  } = props;
  const [listTokenUsb, setListTokenUsb] = useState([]);
  const [listCertSerial, setListCertSerial] = useState([]);
  const [loadingToolSign, setLoadingToolSign] = useState(false);
  const [loadingSign, setLoadingSign] = useState(false);
  const [errorVerify, setTextErrorVerify] = useState(null);
  //
  const [errorConnect, setErrorConnect] = useState(null);
  const [isLoadInfoUSB, setIsLoadInfoUSB] = useState(true);
  //
  const setErrorVerify = (error, msgCode) => {
    setTextErrorVerify(error);
    if (error) {
      errorSignUSBToAirBrake(error, msgCode);
    }
  };
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [contentProcess, setContentProcess] = useState(null);
  const history = useHistory();
  const issueInvoice = useSelector(state => state.issueInvoice);
  const {
    fileDownload,
    fileDownloadName,
    fileDownloadResponse,
    type,
    transferUSB,
    invoiceNumber,
  } = issueInvoice;

  const errorSignUSBToAirBrake = (msg, msgCode) => {
    let userInfo = localStorage.getItem(USER_INFO);
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
    }
    const airbrake = new Notifier({
      projectId: 385659,
      projectKey: "024a6daf814c3ba21fdd71a534df78ee",
    });
    airbrake.notify({
      error: msg,
      context: {
        environment: env.API_AIR_BRAKE_ENV,
      },
      params: {
        msgCode: msgCode,
        id: transferData.id,
        user: userInfo?.userName,
        type: "Hóa đơn",
        action: "Sign USB Token",
      },
    });
  };

  useEffect(() => {
    if (isOpen) {
      connectUSB();
    }
  }, [isOpen]);

  const connectUSB = () => {
    setContentProcess(null);
    setLoadingSign(false);
    setErrorConnect(null);
    setErrorVerify(null);
    setListTokenUsb([]);
    setListCertSerial([]);
    setLoadingToolSign(true);
    let flag = false;

    const timer = setTimeout(() => {
      setLoadingToolSign(flag => {
        if (flag) {
          setErrorConnect(ERROR_CONNECT_TOOL_USB);
          return false;
        }
        return true;
      });
    }, 7000);

    client.healthcheck(USB_TOKEN_URL, res => {
      if (flag) return;
      clearTimeout(timer);
      flag = true;
      if (res === true) {
        getInfoUSB();
      } else {
        setLoadingToolSign(false);
        setErrorConnect(ERROR_CONNECT_TOOL_USB);
        errorSignUSBToAirBrake(ERROR_CONNECT_TOOL_USB);
      }
    });
    reset();
  };

  const getInfoUSB = () => {
    setErrorConnect(null);
    setIsLoadInfoUSB(true);
    setLoadingToolSign(false);
    client.getUsbToken(
      USB_TOKEN_URL,
      {
        //   tokenPin: "12345678",
        tokenSerial: "",
        version: "1.0.0",
      },
      msg => {
        setIsLoadInfoUSB(false);
        if (msg.msgCode === "SUCCESS") {
          setListTokenUsb(
            msg.listTokenUsb.map(item => {
              return {
                slot: item.slot,
                tokenName: item.tokenName,
                libName: item.libName,
                value: item.tokenSerial,
                label: item.tokenName,
              };
            })
          );
        } else {
          const error = getError(msg);
          setErrorConnect(error);
          setErrorVerify(error, msg.msgCode);
        }
      }
    );
  };

  const schema = yup.object().shape({
    tokenSerial: yup.object().required(
      t("form.validate.select", {
        title: t(`usbtoken.tokenSerial`),
      })
    ),
    pin: yup.string().required(
      t("form.validate.required", {
        title: t(`usbtoken.pin`),
      })
    ),
    certSerial: yup.object(),
  });

  useEffect(() => {
    switch (type) {
      case TRANSFER_USB_INVOICE_SUCCESS:
        addToast(t("usbtoken.transfer.success"), {
          appearance: "success",
          autoDismiss: true,
        });
        setLoadingSign(false);
        setContentProcess(null);
        toggle();
        resetDataFunc();
        dispatch(resetTransferUsbInvoice());
        if (location?.pathname === "/invoice/new") {
          history.push(`/invoice/all`);
        }
        break;
      case TRANSFER_USB_INVOICE_FAIL:
        const errorMess = transferUSB.error
          ? transferUSB.error
          : t("usbtoken.transfer.error");
        addToast(errorMess, {
          appearance: "error",
          autoDismiss: true,
        });
        errorSignUSBToAirBrake(errorMess, "TRANSFER_USB_INVOICE");
        setLoadingSign(false);
        setContentProcess(null);
        dispatch(resetTransferUsbInvoice());
        break;
      case GENERATE_NUMBER_INVOICE_SUCCESS:
        setContentProcess(
          "Khởi tạo số hóa đơn thành công. Đang thực hiện ký số USB token"
        );
        dispatch(
          downloadXmlFunc(
            invoiceNumber.data,
            "test.xml",
            "text",
            typeInvoiceAnother
          )
        );
        dispatch(resetGenerateNumberInvoice());
        break;
      case GENERATE_NUMBER_INVOICE_FAIL:
        addToast(invoiceNumber.error, {
          appearance: "error",
          autoDismiss: true,
        });
        setErrorVerify("Khởi tạo số hóa đơn thất bại");
        setLoadingSign(false);
        dispatch(resetGenerateNumberInvoice());
        break;
      case DOWNLOAD_XML_ISSUE_INVOICE_SUCCESS:
        if (isOpen) {
          signAndRelease();
          resetDownloadXmlIssueInvoice();
        }
        break;
      case DOWNLOAD_XML_ISSUE_INVOICE_FAIL:
        if (isOpen) {
          setContentProcess(null);
          setErrorVerify("Lấy file XML đã khởi tạo số hóa đơn thất bại");
          setLoadingSign(true);
          resetDownloadXmlIssueInvoice();
        }
        break;
      default:
        break;
    }
  }, [type]);

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  const submitForm = values => {
    setLoadingSign(true);
    setErrorVerify(null);
    // let flag = false;
    // client.checkLogin(
    //   USB_TOKEN_URL,
    //   {
    //     tokenSerial: getValues("tokenSerial").value,
    //     tokenPin: getValues("pin"),
    //     // listUid: ["99999999999"],
    //     listUid: [transferData.mst],
    //     version: "1.0.0",
    //   },
    //   res => {
    //     if (flag) return;
    //     if (res.msgCode === "SUCCESS") {
    //       dispatch(generateNumberInvoice(transferData.id));
    //     } else {
    //       setLoadingSign(false);
    //       let errorMessage = getError(res.msgCode);
    //       setErrorVerify(errorMessage);
    //     }
    //     flag = true;
    //   }
    // );
    dispatch(generateNumberInvoice(transferData.id, typeInvoiceAnother));
  };

  const approveUSB = values => {
    setLoadingSign(true);
    setErrorVerify(null);
    let flag = false;
    const tokenUsb = listTokenUsb.find(
      item => item.value === getValues("tokenSerial").value
    );
    client.listCertByTokenSerial(
      USB_TOKEN_URL,
      {
        libName: tokenUsb.libName,
        tokenSerial: getValues("tokenSerial").value,
        tokenName: tokenUsb.tokenName,
        slot: tokenUsb.slot,
        tokenPin: getValues("pin"),
      },
      resCert => {
        if (flag) return;
        setLoadingSign(false);
        if (resCert.msgCode === "SUCCESS") {
          if (resCert.listCertificate && resCert.listCertificate.length > 0) {
            const listSerialValid = resCert.listCertificate
              .filter(item => item.valid)
              .map(item => {
                return {
                  value: item.certSerialNumber,
                  label: item.certSerialNumber,
                };
              });
            setListCertSerial(listSerialValid);
            setValue("certSerial", listSerialValid[0]);
          } else {
            setErrorVerify("Không có thông tin Cert serial number hợp lệ");
          }
        } else {
          let errorMessage = getError(resCert);
          setErrorVerify(errorMessage, resCert.msgCode);
        }
        flag = true;
      }
    );
  };

  const signAndRelease = () => {
    if (!fileDownloadResponse) {
      setLoadingSign(false);
      setErrorVerify("Không có file xml để ký");
      return;
    }
    let flag = false;
    setContentProcess("Hệ thống đang ký số USB token");
    const tokenUsb = listTokenUsb.find(
      item => item.value === getValues("tokenSerial").value
    );
    client.signEin(
      USB_TOKEN_URL,
      {
        tokenUsb: {
          tokenSerial: getValues("tokenSerial").value,
          tokenPin: getValues("pin"),
          //   version: "1.0.0",
          libName: tokenUsb.libName,
          //   tokenName: tokenUsb.tokenName,
          slot: tokenUsb.slot,
          // listUid: ["99999999999"],
          certSerial: getValues("certSerial").value,
          listUid: [transferData.mst],
        },
        dataList: [
          {
            aggId: transferData.id,
            signXpath: "HDon|DSCKS|NBan",
            documentBase64: fileDownloadResponse,
          },
        ],
        cmd: {
          signerName: "",
          signerLocation: "Ho Chi Minh",
          signatureReason: "I agree the agreement",
          signingHints: {
            showSignatureImage: true,
            location: "FIELD",
            x: 0.0,
            y: 0.0,
            width: 0.0,
            height: 0.0,
            marginX: 0.0,
            marginY: 0.0,
            fieldName: "rootField.child1.sign1",
            signaturePosition: "BOTTOM_RIGHT",
          },
          signerType: "O",
        },
      },
      resSign => {
        if (flag) return;
        setContentProcess(null);
        if (resSign.msgCode === "SUCCESS") {
          if (resSign.dataList.length > 0) {
            // console.log(
            //   "🚀 ~ file: VerifyPinUSBModal.js ~ line 293 ~ signAndRelease ~ resSign.dataList",
            //   resSign.dataList[0].xmlSignBase64
            // );
            setContentProcess(
              "Ký số USB token thành công. Hệ thống sẽ phát hành hóa đơn"
            );
            dispatch(
              transferUsbInvoice(
                transferData.id,
                transferData.type,
                resSign.dataList[0].xmlSignBase64
              )
            );
          } else {
            setLoadingSign(false);
            setErrorVerify("Không có file ký thành công trả về");
          }
        } else {
          let errorMessage = getError(resSign);
          setLoadingSign(false);
          setErrorVerify(errorMessage, resSign.msgCode);
        }
        flag = true;
      }
    );
  };

  const getError = mes => {
    let errorMessage = mes.msg;
    if (mes.msgCode === "CKR_PIN_INCORRECT") {
      errorMessage = "Sai mã số PIN!";
    }
    if (mes.msgCode === "SERIAL_USB_NOT_MATCH") {
      errorMessage = "Serial USB token không trùng với đã chọn!";
    }
    if (mes.msgCode === "CAN_NOT_FIND_VALID_CERT") {
      errorMessage = "Không tìm thấy cert hợp lệ!";
    }
    if (mes.msgCode === "USB_TOKEN_NOT_FOUND") {
      errorMessage = "Không phát hiện thiết bị USB token!";
    }
    if (mes.msgCode === "USB_TOKEN_EXPIRED") {
      errorMessage = "USB token hết hạn!";
    }
    if (mes.msgCode === "UID_NOT_MATCH") {
      errorMessage = `MST hóa đơn (${transferData.mst}) không trùng với MST của USB token`;
    }
    return errorMessage;
  };

  const onChangeUsbToken = () => {
    setErrorVerify(null);
    setValue("pin", "");
    setListCertSerial([]);
    // setValue("certSerial", null);
  };

  return (
    <Modal
      size="lg"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      // style={{ maxWidth: "80%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      //   toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>{t("usbtoken.title")}</Label>
        </ModalHeader>
        {loadingToolSign ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="2"
              countButton="2"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              {errorConnect ? (
                <React.Fragment>
                  <div
                    className="text-danger font-size-16"
                    style={{ marginTop: "3px" }}
                  >
                    {errorConnect}
                  </div>
                  <div
                    // to={`/file/4Si_Signer.zip`}
                    // target="_blank"
                    // download
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      downloadToolUsbToken();
                    }}
                    className="mt-1 d-flex align-items-center font-size-16"
                  >
                    <i className="bx bx-usb font-size-16 align-middle me-1 text-info" />
                    Tải file kết nối USB Token
                  </div>
                </React.Fragment>
              ) : !isLoadInfoUSB ? (
                listTokenUsb.length > 0 ? (
                  <Row form>
                    {/* Loại USB */}
                    {/* {fileDownloadResponse && JSON.stringify(fileDownloadResponse)} */}
                    <Col>
                      <FormGroup className="mb-2">
                        {generateSelectField(
                          t("usbtoken.tokenSerial"),
                          true,
                          errors,
                          "tokenSerial",
                          t("placeholder.select", {
                            title: t("usbtoken.tokenSerial"),
                          }),
                          errorConnect !== null || loadingSign,
                          control,
                          listTokenUsb,
                          "auto",
                          onChangeUsbToken
                        )}
                      </FormGroup>
                    </Col>
                    {/* Mã pin*/}
                    <Col>
                      <FormGroup className="mb-2">
                        {generateInputField(
                          t("usbtoken.pin"),
                          true,
                          "text",
                          errors,
                          touchedFields,
                          "pin",
                          t("placeholder.enter", {
                            title: t("usbtoken.pin"),
                          }),
                          register,
                          errorConnect !== null || loadingSign
                        )}
                      </FormGroup>
                    </Col>
                    {/* Cert serial*/}
                    {listCertSerial.length > 0 && (
                      <Col>
                        <FormGroup className="mb-2">
                          {generateSelectField(
                            "Cert serial number",
                            listCertSerial.length > 0,
                            errors,
                            "certSerial",
                            t("placeholder.select", {
                              title: "Cert serial number",
                            }),
                            errorConnect !== null || loadingSign,
                            control,
                            listCertSerial
                          )}
                        </FormGroup>
                      </Col>
                    )}
                  </Row>
                ) : (
                  <Row>
                    <div className="text-warning font-size-14">
                      {ERROR_GET_INFO_USB}
                    </div>
                  </Row>
                )
              ) : (
                <Row>
                  <div className="text-primary font-size-14  d-flex gap-2 align-items-center">
                    <Spinner color="primary" size="sm" />
                    {GET_INFO_USB}
                  </div>
                </Row>
              )}
              {errorVerify && (
                <MessageFormValidate error={errorVerify}></MessageFormValidate>
              )}

              {contentProcess && (
                <div className="text-primary font-size-14 d-flex gap-2 align-items-center">
                  <Spinner color="primary" size="sm" />
                  {contentProcess}
                </div>
              )}
            </ModalBody>
            <ModalFooter>
              {!errorConnect ? (
                <React.Fragment>
                  {listTokenUsb.length > 0 && !isLoadInfoUSB ? (
                    <React.Fragment>
                      {listCertSerial.length === 0 ? (
                        <Button
                          type="button"
                          color="primary"
                          // disabled={isDisableButton}
                          className="me-2 btn-label"
                          disabled={
                            errorConnect !== null ||
                            loadingSign ||
                            loadingToolSign
                          }
                          onClick={handleSubmit(approveUSB)}
                        >
                          <i className="bx bx-usb label-icon" />
                          Xác nhận ký số với loại USB đã chọn
                        </Button>
                      ) : (
                        <Button
                          type="button"
                          color="primary"
                          // disabled={isDisableButton}
                          className="me-2 btn-label"
                          disabled={
                            errorConnect !== null ||
                            loadingSign ||
                            loadingToolSign
                          }
                          onClick={handleSubmit(submitForm)}
                        >
                          <i className="fas fa-signature label-icon" />
                          {t("usbtoken.sign")}
                        </Button>
                      )}
                    </React.Fragment>
                  ) : (
                    !isLoadInfoUSB && (
                      <Button
                        type="button"
                        color="primary"
                        // disabled={isDisableButton}
                        className="me-2 btn-label"
                        onClick={() => {
                          connectUSB();
                        }}
                      >
                        <i className="bx bx-reset label-icon" />
                        Recheck thông tin USB token
                      </Button>
                    )
                  )}
                </React.Fragment>
              ) : (
                <Button
                  type="button"
                  color="primary"
                  // disabled={isDisableButton}
                  className="me-2 btn-label"
                  onClick={() => {
                    connectUSB();
                  }}
                >
                  <i className="bx bx-reset label-icon" />
                  Restart lại
                </Button>
              )}

              <Button
                type="button"
                color="danger"
                // disabled={isDisableButton}
                className="me-2"
                onClick={toggle}
              >
                {t("usbtoken.close")}
              </Button>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

VerifyPinUSBModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  isCreateAdjust: PropTypes.bool,
  commonStatus: PropTypes.any,
  t: PropTypes.any,
  transferData: PropTypes.any,
  resetDataFunc: PropTypes.any,
  downloadXmlFunc: PropTypes.any,
  typeInvoiceAnother: PropTypes.any,
};

export default VerifyPinUSBModal;
